/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AmortizationSchedule } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class LoanApplicationScheduleService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param amount 
     * @param tenure 
     * @param tenureType 
     * @param interestRate 
     * @param interestratePeriodType 
     * @param interestcalmethod 
     * @param supportDecimal 
     * @param graceperiodtenure 
     * @param hasInterestRateInGracePeriod 
     * @param hasFixedYearlyInterest 
     * @param excludeNonWorkingDays 
     * @param nonWorkingDayConfig 
     * @param userId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiLoanapplicationAmortizationScheduleGet(amount?: number, tenure?: number, tenureType?: string, interestRate?: number, interestratePeriodType?: string, interestcalmethod?: string, supportDecimal?: boolean, graceperiodtenure?: number, hasInterestRateInGracePeriod?: boolean, hasFixedYearlyInterest?: boolean, excludeNonWorkingDays?: boolean, nonWorkingDayConfig?: string, userId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<AmortizationSchedule>;
    public apiLoanapplicationAmortizationScheduleGet(amount?: number, tenure?: number, tenureType?: string, interestRate?: number, interestratePeriodType?: string, interestcalmethod?: string, supportDecimal?: boolean, graceperiodtenure?: number, hasInterestRateInGracePeriod?: boolean, hasFixedYearlyInterest?: boolean, excludeNonWorkingDays?: boolean, nonWorkingDayConfig?: string, userId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpResponse<AmortizationSchedule>>;
    public apiLoanapplicationAmortizationScheduleGet(amount?: number, tenure?: number, tenureType?: string, interestRate?: number, interestratePeriodType?: string, interestcalmethod?: string, supportDecimal?: boolean, graceperiodtenure?: number, hasInterestRateInGracePeriod?: boolean, hasFixedYearlyInterest?: boolean, excludeNonWorkingDays?: boolean, nonWorkingDayConfig?: string, userId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpEvent<AmortizationSchedule>>;
    public apiLoanapplicationAmortizationScheduleGet(amount?: number, tenure?: number, tenureType?: string, interestRate?: number, interestratePeriodType?: string, interestcalmethod?: string, supportDecimal?: boolean, graceperiodtenure?: number, hasInterestRateInGracePeriod?: boolean, hasFixedYearlyInterest?: boolean, excludeNonWorkingDays?: boolean, nonWorkingDayConfig?: string, userId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (amount !== undefined && amount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>amount, 'amount');
        }
        if (tenure !== undefined && tenure !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>tenure, 'tenure');
        }
        if (tenureType !== undefined && tenureType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>tenureType, 'tenureType');
        }
        if (interestRate !== undefined && interestRate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>interestRate, 'interestRate');
        }
        if (interestratePeriodType !== undefined && interestratePeriodType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>interestratePeriodType, 'interestratePeriodType');
        }
        if (interestcalmethod !== undefined && interestcalmethod !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>interestcalmethod, 'interestcalmethod');
        }
        if (supportDecimal !== undefined && supportDecimal !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>supportDecimal, 'supportDecimal');
        }
        if (graceperiodtenure !== undefined && graceperiodtenure !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>graceperiodtenure, 'graceperiodtenure');
        }
        if (hasInterestRateInGracePeriod !== undefined && hasInterestRateInGracePeriod !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>hasInterestRateInGracePeriod, 'hasInterestRateInGracePeriod');
        }
        if (hasFixedYearlyInterest !== undefined && hasFixedYearlyInterest !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>hasFixedYearlyInterest, 'hasFixedYearlyInterest');
        }
        if (excludeNonWorkingDays !== undefined && excludeNonWorkingDays !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>excludeNonWorkingDays, 'excludeNonWorkingDays');
        }
        if (nonWorkingDayConfig !== undefined && nonWorkingDayConfig !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nonWorkingDayConfig, 'nonWorkingDayConfig');
        }
        if (userId !== undefined && userId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>userId, 'userId');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<AmortizationSchedule>(`${this.configuration.basePath}/api/loanapplication/amortization-schedule`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param amount 
     * @param tenure 
     * @param tenureType 
     * @param interestRate 
     * @param interestratePeriodType 
     * @param interestcalmethod 
     * @param supportDecimal 
     * @param graceperiodtenure 
     * @param hasInterestRateInGracePeriod 
     * @param hasFixedYearlyInterest 
     * @param excludeNonWorkingDays 
     * @param nonWorkingDayConfig 
     * @param tenantId 
     * @param userId 
     * @param skipCount 
     * @param maxResultCount 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiLoanapplicationAmortizationScheduleMemberGet(amount?: number, tenure?: number, tenureType?: string, interestRate?: number, interestratePeriodType?: string, interestcalmethod?: string, supportDecimal?: boolean, graceperiodtenure?: number, hasInterestRateInGracePeriod?: boolean, hasFixedYearlyInterest?: boolean, excludeNonWorkingDays?: boolean, nonWorkingDayConfig?: string, tenantId?: number, userId?: number, skipCount?: number, maxResultCount?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<AmortizationSchedule>;
    public apiLoanapplicationAmortizationScheduleMemberGet(amount?: number, tenure?: number, tenureType?: string, interestRate?: number, interestratePeriodType?: string, interestcalmethod?: string, supportDecimal?: boolean, graceperiodtenure?: number, hasInterestRateInGracePeriod?: boolean, hasFixedYearlyInterest?: boolean, excludeNonWorkingDays?: boolean, nonWorkingDayConfig?: string, tenantId?: number, userId?: number, skipCount?: number, maxResultCount?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpResponse<AmortizationSchedule>>;
    public apiLoanapplicationAmortizationScheduleMemberGet(amount?: number, tenure?: number, tenureType?: string, interestRate?: number, interestratePeriodType?: string, interestcalmethod?: string, supportDecimal?: boolean, graceperiodtenure?: number, hasInterestRateInGracePeriod?: boolean, hasFixedYearlyInterest?: boolean, excludeNonWorkingDays?: boolean, nonWorkingDayConfig?: string, tenantId?: number, userId?: number, skipCount?: number, maxResultCount?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpEvent<AmortizationSchedule>>;
    public apiLoanapplicationAmortizationScheduleMemberGet(amount?: number, tenure?: number, tenureType?: string, interestRate?: number, interestratePeriodType?: string, interestcalmethod?: string, supportDecimal?: boolean, graceperiodtenure?: number, hasInterestRateInGracePeriod?: boolean, hasFixedYearlyInterest?: boolean, excludeNonWorkingDays?: boolean, nonWorkingDayConfig?: string, tenantId?: number, userId?: number, skipCount?: number, maxResultCount?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (amount !== undefined && amount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>amount, 'amount');
        }
        if (tenure !== undefined && tenure !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>tenure, 'tenure');
        }
        if (tenureType !== undefined && tenureType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>tenureType, 'tenureType');
        }
        if (interestRate !== undefined && interestRate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>interestRate, 'interestRate');
        }
        if (interestratePeriodType !== undefined && interestratePeriodType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>interestratePeriodType, 'interestratePeriodType');
        }
        if (interestcalmethod !== undefined && interestcalmethod !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>interestcalmethod, 'interestcalmethod');
        }
        if (supportDecimal !== undefined && supportDecimal !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>supportDecimal, 'supportDecimal');
        }
        if (graceperiodtenure !== undefined && graceperiodtenure !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>graceperiodtenure, 'graceperiodtenure');
        }
        if (hasInterestRateInGracePeriod !== undefined && hasInterestRateInGracePeriod !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>hasInterestRateInGracePeriod, 'hasInterestRateInGracePeriod');
        }
        if (hasFixedYearlyInterest !== undefined && hasFixedYearlyInterest !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>hasFixedYearlyInterest, 'hasFixedYearlyInterest');
        }
        if (excludeNonWorkingDays !== undefined && excludeNonWorkingDays !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>excludeNonWorkingDays, 'excludeNonWorkingDays');
        }
        if (nonWorkingDayConfig !== undefined && nonWorkingDayConfig !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nonWorkingDayConfig, 'nonWorkingDayConfig');
        }
        if (tenantId !== undefined && tenantId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>tenantId, 'tenantId');
        }
        if (userId !== undefined && userId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>userId, 'UserId');
        }
        if (skipCount !== undefined && skipCount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>skipCount, 'SkipCount');
        }
        if (maxResultCount !== undefined && maxResultCount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>maxResultCount, 'MaxResultCount');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<AmortizationSchedule>(`${this.configuration.basePath}/api/loanapplication/amortization-schedule/member`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
